export default "__VITE_ASSET__Dy8P$LNB__"